<template>
    <AppLayout>
        <create
            :errors="errors"
            :error-bags="errorBags"
            :modal="showCreateModal"
            :tenants="tenants"
            @close="showCreateModal = value"
        />

        <update
            :errors="errors"
            :error-bags="errorBags"
            :modal="showUpdateModal"
            :tenants="tenants"
            :project="project"
            @close="showUpdateModal = value"
        />

        <div class="flex justify-between">
            <h2 class="text-lg font-medium mb-2">{{ $t("projects.title") }}</h2>
            <button-primary class="mb-3 ml-auto" @click="goToCreateRoute">{{
                $t("projects.buttons.new")
            }}</button-primary>
        </div>

        <div class="flex flex-col bg-gray-100 border border-gray-200 mb-4 rounded">
            <div
                class="w-full border-b-2 bg-gray-200 px-2 py-3 flex items-center justify-between"
                @click="filterCollapse = !filterCollapse"
            >
                <div class="flex items-center">
                    <FaIcon class="w-6 h-6" icon="filter" />
                    <p class="ml-2 text-sm">Filter</p>
                </div>
                <div>
                    <FaIcon v-if="!filterCollapse" class="w-6 h-6" icon="chevron-up" />
                    <FaIcon v-if="filterCollapse" class="w-6 h-6" icon="chevron-down" />
                </div>
            </div>
            <transition name="slide">
                <div v-if="filterCollapse" class="w-full">
                    <div class="sm:w-1/3 pr-2 px-2 py-3">
                        <label for="tenant_id" class="text-sm">Tenant Kiezen</label>
                        <div class="flex flex-row">
                            <select
                                id="tenant_id"
                                v-model="changeCurrentSelected"
                                name="tenant_id"
                                class="
                                    mt-1
                                    block
                                    w-full
                                    pl-3
                                    pr-10
                                    py-2
                                    text-base
                                    border-gray-300
                                    focus:outline-none
                                    focus:ring-indigo-500
                                    focus:border-indigo-500
                                    text-sm
                                    rounded-md
                                    m-2
                                "
                                @input="ChangeFilterByTenant($event.target.value)"
                            >
                                <option :value="false" selected disabled>Selecteer een Tenant</option>
                                <option v-for="record in tenants" :key="record.id" :value="record.id">
                                    {{ record.name }}
                                </option>
                            </select>

                            <FaIcon
                                class="text-red-600 my-auto text-xl m-2"
                                icon="trash"
                                @click="ChangeFilterByTenant(null)"
                            >
                            </FaIcon>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <Table
            :headers="['id', 'name', 'type', 'tenant', 'actions']"
            :content="projects.data"
            @action-click="(data) => deactivateItem(data.index)"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import ButtonPrimary from "@/Components/ButtonPrimary";
import Create from "@/Pages/Universal/Projects/Create";
import Update from "@/Pages/Universal/Projects/Update";
import Table from "@/Components/Table";
import { Inertia } from "@inertiajs/inertia";
import { ref } from "vue";
import FaIcon from "@/Components/FaIcon";

export default {
    name: "IndexProject",
    components: {
        FaIcon,
        AppLayout,
        ButtonPrimary,
        Create,
        Update,
        Table,
    },
    props: {
        errors: Object,
        errorBags: Object,
        tenants: Object,
        projects: Object,
        project: Object,
        modal: String,
        openFilter: Boolean,
    },
    setup(props) {
        const currentUrl = new URLSearchParams(window.location.search);
        const changeCurrentSelected = ref(currentUrl.get("tenant") || false);
        const showCreateModal = ref(false);
        const showUpdateModal = ref(false);
        const filterCollapse = ref(props.openFilter);

        if (props.modal === "Universal/Projects/Create") {
            showCreateModal.value = true;
        }

        if (props.modal === "Universal/Projects/Update") {
            showUpdateModal.value = true;
        }

        const deactivateItem = (index) => {
            Inertia.delete(route("universal.projects.destroy", props.projects.data[index].id));
        };

        const ChangeFilterByTenant = (value) => {
            if (value) {
                Inertia.get(route("universal.projects.index"), { tenant: value });
                return;
            }

            Inertia.get(route("universal.projects.index"));
        };

        const goToCreateRoute = () => {
            Inertia.get(route("universal.projects.create"));
        };

        return {
            showCreateModal,
            filterCollapse,
            showUpdateModal,
            goToCreateRoute,
            changeCurrentSelected,
            deactivateItem,
            ChangeFilterByTenant,
        };
    },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
    transition: all 0.2s;
    max-height: 230px;
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    max-height: 0px;
}
</style>
